export default  {	
	data () {
		return { 
			active:0,
			dias: 30,
			mesPeriodo: {},
			anoPeriodo: {},
			ingresoccf: null,
			salarioccf: 0,
			indexccf: -1,
			salarioBase: 0,
			ingreso: null,
			errorsAportes: null,
			nameSearchs: 'AportesCentros',
			showAporteRegistrado:false,
			linkaporte: '',
			getBackendData: false,
			novedad: null,
			salarioproporcional: 0,
			statusDescargar: false,
			id_afiliacion_registro: null,
		}
	},
	destroyed () { 
		this.limpiarSearchs()
		this.resetCrud({state:'dataGet/aportes_cuentas/data'})
		this.updateCrud({state: 'dataForm/aportes_cuentas/servicios_activos',data: []})	
	},
	async created () { 	
		this.searchSw.value=''
		this.updateDataForm({state: 'servicios_activos',data: []})	
		this.mesPeriodo = {id: this.fecha().fecha.mesHoy, name: this.gettersDatalist('list_mes',this.fecha().fecha.mesHoy)[0].name}
		this.anoPeriodo = {id: this.fecha().fecha.anoHoy, name: this.gettersDatalist('list_ano',this.fecha().fecha.anoHoy)[0].name}
	},
	methods:{
		async onInit()
		{
			await this.updateDataForm({state: 'precios', data: await this.buscarIdb({tabla:'precios', campo: 'id_datos_contacto', value: 1}) })
			await this.updateDataForm({state: 'base', data: await this.buscarIdb({tabla:'base', campo: 'id', value: 1}) })	
		}
	}
}
